// Utils
import { isSketch } from '../../../../../common/elements/utils/elementTypeUtils';

// Selectors
import { getCurrentModalElementId } from '../../../modal/elementModalCommonSelector';
import { getElement } from '../../../selectors/elementSelector';

/**
 * Checks if the sketch modal is currently open.
 */
export const isSketchModalOpen = (state: Immutable.Map<string, object>): boolean => {
    const currentModalElementId = getCurrentModalElementId(state);

    if (!currentModalElementId) {
        return false;
    }

    const element = getElement(state, { elementId: currentModalElementId });

    if (!element) return false;

    return isSketch(element);
};
